export const ContributionType = {
  contributionCourse: 'ContributionCourse',
  contributionOneToOne: 'ContributionOneToOne',
  contributionLocalEvent: 'ContributionLocalEvent',
  contributionWebinar: 'ContributionWebinar',
  contributionMembership: 'ContributionMembership',
};
